export default __webpack_public_path__ + "static/media/break.1ba2da23.svg";